import Header from './Headers/HeaderMain.js';
import '../styles/Home.scss';
import '../styles/mobileMain.scss';
import FooterMain from './Footers/FooterMain.js';
import React from 'react';
import fish from '../images/fish.png';
import spaghetti from '../images/spaghetti.png';
import pizza from '../images/pizza.png';
import dish from '../images/dish.png';
import fries from '../images/fries.png';
import orange from '../images/orange.png';
import mainDish from '../images/mainDish.png';
import googlePlayIcon from '../images/GooglePlay.png';
import phoneApp from '../images/phoneApp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-regular-svg-icons';
import { faDollarSign, faTruckFast, faScroll, faCarrot, faLemon, faPepperHot,
     faAppleWhole, faLeaf, faPizzaSlice, faCartPlus, faShareNodes, faArrowLeft,
      faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faApple } from '@fortawesome/free-brands-svg-icons';

 

function Home() {
    
    return (
        <div className = "Home">
            <Header/>    
                <div id = "getStarted">
                    <div id = "leftMain">
                        <div id = "fastDelivery">
                            <span>Fast Delivery</span>
                        </div>
                            <p>Fresh Food. Fast Delivery.<br></br>Taste That Brings You Back</p>
                            <p>Order delicious meals made from fresh ingredients and delivered straight to your door.<br></br>
Fast, simple and always satisfying.</p>
                        <div id = "getStartedButtons">
                            <button id = "getStartedButton">Order Now</button>
                            <button id = "watchVideo">
                                <FontAwesomeIcon icon={faCirclePlay} fontSize = "25px" color = "#FCC647"/>
                            </button>
                            <span>View Menu</span>
                        </div>
                    </div>

                    <div id = "rightMain">
                        <FontAwesomeIcon icon = {faCarrot} id = "carrot" className = "foodIcons"/>
                        <FontAwesomeIcon icon = {faLemon} id = "lemon" className = "foodIcons"/>
                        <FontAwesomeIcon icon = {faPepperHot} id = "pepper" className = "foodIcons"/>
                        <FontAwesomeIcon icon = {faAppleWhole} id = "appleWhole" className = "foodIcons"/>
                        <FontAwesomeIcon icon = {faLeaf} id = "leaf" className = "foodIcons"/>
                        <FontAwesomeIcon icon = {faPizzaSlice} id = "pizza" className = "foodIcons"/>
                        <img src = {mainDish} id = "mainDish"/>
                        <img src = {orange} id = "orangeImg"/>
                    </div>
                </div>

                <div id = "howItWorks">
                    <span id = "howItWorksSpan">How it works</span>
                    <p>Order your favorite meals in just a few simple steps</p>

                    <div id = "orderNow" className = "howItWorks">
                        <div id = "orderNowCircle" className = "howItWorksCircles">
                            <FontAwesomeIcon icon = {faScroll} fontSize = "40px" color = "white" id = "faScroll"/>
                        </div>
                            <span>Choose your meal</span>
                           <p>Browse our menu and pick your favorite dishes in seconds</p>
                    </div>

                    <div id = "getDelivery" className = "howItWorks">
                        <div id = "getDeliveryCircle" className = "howItWorksCircles">
                            <FontAwesomeIcon icon={faTruckFast} fontSize = "40px" color = "white" id = "faTruck"/>
                        </div>
                            <span>Fast Delivery</span>
                            <p>Your food arrives hot and fresh, right at your doorstep</p>
                        </div>

                        <div id = "payment" className = "howItWorks">
                            <div id = "paymentCircle" className = "howItWorksCircles">
                                <FontAwesomeIcon icon = {faDollarSign} fontSize = "40px" color = "white" id = "faDollar"/>
                            </div>
                            <span>Easy Payment</span>
                            <p>Secure and simple checkout with multiple payment options</p>
                        </div>
                </div>

                    <div id = "menuSpan">
                        <span>Popular Dishes</span>
                        <p>Discover our most loved meals, prepared fresh every day</p>
                    </div>

                    <div id = "menu">

                        <div className = "menuItems">
                            <img src = {fish}></img>
                            <span>Grilled Salmon Bowl</span>
                            <p>Fresh salmon with greens, avocado and<br></br> house dressing</p>
                            <span>$18</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {fries}></img>
                            <span>Crispy Chicken & Fries</span>
                            <p>Golden fries with juicy chicken and <br></br>signature sauce</p>
                            <span>$14</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {pizza}></img>    
                            <span>Classic Margherita</span>
                            <p>Fresh mozzarella, basil and rich tomato<br></br> sauce</p>
                            <span>$12</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {dish}></img>
                            <span>Chef’s Special Bowl</span>
                            <p>A perfect mix of flavors crafted by our chef</p>
                            <span>$16</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {spaghetti}></img>
                            <span>Italian Spaghetti</span>
                            <p>Pasta with rich tomato sauce and parmesan cheese</p>
                            <span>$13</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {fish}></img>
                            <span>Grilled Salmon Bowl</span>
                            <p>Fresh salmon with greens, avocado and<br></br> house dressing</p>
                            <span>$18</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {pizza}></img>
                            <span>Classic Margherita</span>
                            <p>Fresh mozzarella, basil and rich tomato <br></br>sauce</p>
                            <span>$12</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>

                        <div className = "menuItems">
                            <img src = {fries}></img>
                            <span>Crispy Chicken & Fries</span>
                            <p>Golden fries with juicy chicken and <br></br>signature sauce</p>
                            <span>$14</span>
                            <button className = "addToCart">
                                <FontAwesomeIcon icon = {faCartPlus}/>
                            </button>
                            <button className = "shareDish">
                                <FontAwesomeIcon icon = {faShareNodes}/>
                            </button>
                        </div>    
                    </div>

                    {/*<div id = "pageChooseCircles">
                        <div id = "leftArrow" className = "pageChooseCircles">
                            <FontAwesomeIcon icon = {faArrowLeft} id = "leftArrowIcon"/>
                        </div>

                        <div id = "one" className = "pageChooseCircles" tabIndex={0}>
                            <span>1</span>
                        </div>

                        <div id = "two" className = "pageChooseCircles" tabIndex={0}>
                            <span>2</span>
                        </div>

                        <div id = "three" className = "pageChooseCircles" tabIndex={0}>
                            <span>3</span>
                        </div>

                        <div id = "four" className = "pageChooseCircles" tabIndex={0}>
                            <span>4</span>
                        </div>

                        <div id = "five" className = "pageChooseCircles" tabIndex={0}>
                            <span>5</span>
                        </div>

                        <div id = "rightArrow" className = "pageChooseCircles">
                            <FontAwesomeIcon icon = {faArrowRight} id = "rightArrowIcon"/>
                        </div>
                    </div>*/}

                    <div id = "downloadTheApp">
                        <p>Get 15% Off Your First Order<br></br>Download Our App</p>
                        <p>Order faster, track your delivery and enjoy exclusive deals<br></br>
                        available only in our mobile app</p>
                        <div id = "stores">
                            <button id = "googlePlay" className = "stores">
                                <img src =  {googlePlayIcon} id = "googlePlayIcon"></img>
                                <span>Download on</span>
                                <span>Google</span>
                                <span>play</span>
                            </button>

                            <button id = "appStore" className = "stores">
                                <FontAwesomeIcon icon = {faApple} id = "appStoreIcon"/>
                                <span>Download on the</span>
                                <span>App Store</span>
                            </button>
                        </div>

                        <div id = "mobileApp">
                            <div id = "phoneAroundCircle"></div>
                                <img src = {phoneApp}></img>
                        </div>

                    </div>
                <FooterMain/>
        </div>
        
    )
}
/*const getStarted = document.getElementById('#getStartedButton');
    const howItWorks = document.getElementById('#howItWorks');
    getStarted.addEventListener('click', () => {
        howItWorks.scrollIntoView(true);
    })*/
export default Home;